/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";

const MedicineListHeader = ({
  reloadList = () => {},
  selectedItemIds = [],
}) => {
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();

  /* ---- bread crumb text ---- */
  const breadcrumbText = [
    {
      title: t("Clinical Management"),
      link: "/admin/clinicalmanagement/medicines",
    },
    { title: t("Medicine") },
  ];

  return (
    <div className="bg-white mt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb breadCrumbText={breadcrumbText} top={false} />
        </div>
        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          {/* <!-- ========== Start refresh Section ========== --> */}
          <Link
            onClick={reloadList}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>
          {/* <!-- ========== End refresh Section ========== --> */}

          {/* <!-- ========== Start Action Dropdown Section ========== --> */}
          <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("Action")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>
            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              <li>
                <Link
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedItemIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  to="#"
                  data-bs-toggle={
                    selectedItemIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedItemIds.length === 0
                      ? undefined
                      : "#manageLabelModal"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    label
                  </span>
                  <span className="d-block">{t("Manage Label")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedItemIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  // onClick={() => { if (selectedItemIds.length > 0) { /* Update Rank Logic */ } }}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    progress_activity
                  </span>
                  <span className="d-block">{t("Update Rank")}</span>
                </Link>
              </li>
              <hr className="dropdown-divider" />
              <li>
                <Link
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedItemIds.length === 0
                      ? "disabled text-muted"
                      : "text-danger"
                  }`}
                  to="#"
                  data-bs-toggle={
                    selectedItemIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedItemIds.length === 0
                      ? undefined
                      : "#deleteWarningModal"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    delete
                  </span>
                  <span className="d-block">{t("Delete")}</span>
                </Link>
              </li>
            </ul>
          </div>
          {/* <!-- ========== End Action Dropdown Section ========== --> */}

          {/* <!-- ========== Start Filter Section ========== --> */}
          <Link
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title={t("Filter")}
          >
            <span className="material-symbols-outlined icon-md me-1">tune</span>
            <span className="fw-semibold small">{t("Filter")}</span>
          </Link>
          {/* <!-- ========== End Filter Section ========== --> */}

          {/* <!-- ========== Start Add New Section ========== --> */}
          <Link
            to="#"
            className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
          >
            <span className="material-symbols-outlined icon-md">add</span>
            <span>{t("Add New")}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};
export default MedicineListHeader;
